import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import {
  CenteredFlexBox,
  FullSizeCenteredFlexBox,
  FullSizeColumn,
} from '../../../Components/FlexBox';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import Chip from '../../../Components/Chip';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';
import IconButton from '../../../Components/Button/IconButton';
import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';

const ActivityProgressSummary = function ActivityProgressSummary({
  open,
  onToggle,
  status,
  onReload,
}) {
  const intl = useIntl();
  return (
    <FullSizeColumn padding="16px">
      <FullSizeCenteredFlexBox justifyContent="space-between">
        <CenteredFlexBox gap="24px">
          <Typography variant="h6" color="primary">
            {intl.messages.ACTIVITY_PROGRESS}
          </Typography>

          {status && (
            <Chip fontSize="1.5rem" label={capitalize(status)} height="unset" />
          )}
          {open && (
            <IconButton
              id="reload-chart"
              title="RELOAD"
              onClick={onReload}
              size="large"
            >
              <ReplayRoundedIcon fontSize="24px" />
            </IconButton>
          )}
        </CenteredFlexBox>

        <IconButton id="toggle-chart" onClick={onToggle} size="large">
          {open ? (
            <CloseRoundedIcon fontSize="24px" />
          ) : (
            <KeyboardArrowUpRoundedIcon fontSize="24px" />
          )}
        </IconButton>
      </FullSizeCenteredFlexBox>
    </FullSizeColumn>
  );
};

export default ActivityProgressSummary;
